export default __webpack_public_path__ + "static/media/porterbuddy.c53013f8.svg";